module.exports = __webpack_public_path__ + "static/img/xg1-2.add9923.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/xg1-2.png
// module id = 722
// module chunks = 0